// @ts-nocheck
import { build280gAnalysisResults } from './build280gAnalysisResults';

/** Full JSON persisted with POST …/analyses/{id}/runs (stored in `AnalysisRunSnapshots`). */
export function build280gRunSnapshotPayload(formData: Record<string, unknown> | null | undefined) {
  const workflowData = JSON.parse(JSON.stringify(formData ?? {}));
  const analysisResults = build280gAnalysisResults(formData || {});
  return {
    version: 1,
    capturedAtISO: new Date().toISOString(),
    workflowData,
    analysisResults,
  };
}
